import 'foundation-sites';
import 'sticky-sidebar';

(function($) {
    $(document).foundation();

    // initiate headroom
    // http://wicky.nillia.ms/headroom.js/
    const pageHeader = document.querySelector(".js-page-header");
    // construct an instance of Headroom, passing the element
    const headroom  = new Headroom(pageHeader, {
        offset: 200,
        tolerance: {
            down: 0,
            up: 5
        }
    });
    // initialise
    headroom.init();

    function setHeaderHeight() {
        const headerPlaceholder = $('.js-header-placeholder');
        const mobileMenu = $('.js-mobile-menu');
        const height = $('.js-page-header').outerHeight();
        headerPlaceholder.css('height', height);
        mobileMenu.css('paddingTop', height);
    }
    setHeaderHeight();
    $(window).on('resize', setHeaderHeight);

    const homepageHeroArrow = $('.js-homepage-hero-arrow');
    const homepageHeroTarget = homepageHeroArrow.attr('data-target');
    homepageHeroArrow.on('click', function() {
        const offset = 80;
        const scrollTo = $(homepageHeroTarget).offset().top - offset;

        $('html, body').animate({
            scrollTop: scrollTo
        }, 500);
    });

    const programLink = $('.js-program-section-link');
    programLink.on('click', function(e) {
        const offset = 50;
        const target = $(this).attr('href');
        const scrollTo = $(target).offset().top - offset;

        $('html, body').animate({
            scrollTop: scrollTo
        }, 500);

        console.log('test');

        e.preventDefault();
    });

    const slider = $('.js-quote-slider');
    if (slider.is('*')) {
        const sliderNav = $('.js-quote-avatar-slider');
        slider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: true,
            asNavFor: '.js-quote-avatar-slider'
        });
        sliderNav.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            asNavFor: '.js-quote-slider',
            dots: false,
            arrows: false,
            fade: true,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 600,
                    settings: {
                        fade: false,
                        centerMode: true,
                        centerPadding: '200px',
                        focusOnSelect: true
                    }
                }
            ]
        });
    }

    const programsNav = $('.js-programs-nav');
    if (programsNav.is('*')) {
        new StickySidebar('.js-programs-nav', {
            topSpacing: 70,
            bottomSpacing: 20,
            containerSelector: '.js-program-content',
            innerWrapperSelector: '.js-programs-nav__inner'
        });
    }
})(jQuery);



// WEBPACK FOOTER //
// ../src/scripts/main.js